export type BuildConfig = {
  environment: typeof process.env.NODE_ENV;
} & Record<string, unknown>;

// This is configured in the rspack.common.ts via the define plugin
declare global {
  const TDP_BASE_CONFIG: BuildConfig;
}

/**
 * Injection point for the `TDP_BASE_CONFIG` value passed in via the webpack/rspack DefinePlugin.
 *
 * The values are derived from the environment variables during the build process.
 * @see client/config/rspack.common.ts
 * @returns the base build configuration.
 */
export function loadBuildConfig(): BuildConfig {
  return TDP_BASE_CONFIG;
}
